<header-bar [pageTitle]="title" headingClass="fa-user-o"></header-bar>

<form *ngIf="userForm" [formGroup]="userForm" (ngSubmit)="saveUser(userForm.value, userForm.valid)" novalidate>
  <div class="container mt-5">
    <div class="row">
      <div class="col">
        <div class="card mb-5">
          <div class="card-header text-white bg-primary">
            <div class="row align-items-center">
              <p class="h3 m-0 col">User details</p>
              <div class="col text-right">
                <ng-container *userRoleToggle="[rolesEnum[rolesEnum.SuperAdmin]]">
                  <button type="button" class="btn btn-outline-light btn-sm u-marginBottom--medium mr-3" [disabled]="!userForm.valid" *ngIf="user?.id"
                          (click)="resendSignupInvitationEmail()">
                    Resend signup email
                    <i class="fa fa-envelope ml-2"></i>
                  </button>
                </ng-container>
                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium" [disabled]="!userForm?.valid">
                  Save changes
                  <i class="fa fa-check ml-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" [ngClass]="{ 'has-error': !userForm.controls['email'].valid && userForm.controls['email'].touched }">
                  <label for="email" class="textBody--sm">Email address *</label>
                  <input type="text" id="email" formControlName="email" class="form-control" *ngIf="user == null" />
                  <p *ngIf="user">
                    <span>
                      <strong>{{userForm.controls['email'].value}}</strong>
                    </span>
                  </p>
                  <div *ngIf="userForm.controls['email'].hasError('required') && userForm.controls['email'].touched" class="alert alert-danger">You must include an email.</div>
                  <div *ngIf="userForm.controls['email'].hasError('minlength') && userForm.controls['email'].touched" class="alert alert-danger">Email must be greater than 5 characters.</div>
                  <div *ngIf="userForm.controls['email'].hasError('pattern') && userForm.controls['email'].touched" class="alert alert-danger">Email is invalid.</div>
                </div>

                <hr />

                <div class="row">
                  <div class="col">
                    <div class="form-group" [ngClass]="{ 'has-error': !userForm.controls['firstName'].valid && userForm.controls['firstName'].touched }">
                      <label for="firstName" class="textBody--sm">First name *</label>
                      <input type="text" id="firstName" formControlName="firstName" class="form-control" />
                      <div *ngIf="userForm.controls['firstName'].hasError('required') && userForm.controls['firstName'].touched" class="alert alert-danger">You must include a first name.</div>
                    </div>

                  </div>
                  <div class="col">
                    <div class="form-group" [ngClass]="{ 'has-error': !userForm.controls['lastName'].valid && userForm.controls['lastName'].touched }">
                      <label for="lastName" class="textBody--sm">Last name *</label>
                      <input type="text" id="lastName" formControlName="lastName" class="form-control" />
                      <div *ngIf="userForm.controls['lastName'].hasError('required') && userForm.controls['lastName'].touched" class="alert alert-danger">You must include a last name.</div>
                    </div>
                  </div>
                </div>



                <div class="form-group" [ngClass]="{ 'has-error': !userForm.controls['roleId'].valid && userForm.controls['roleId'].touched }">
                  <label class="textBody--sm">User Role</label>
                  <ng-select id="ddlRoles" [items]="roles" [active]="selectedRole" placeholder="Select a role" (selected)="roleSelected($event)">
                  </ng-select>
                </div>

                <div class="form-group" [ngClass]="{ 'has-error': !userForm.controls['companyId'].valid && userForm.controls['companyId'].touched }"
                     *ngIf="selectedRoleName=='Client'">
                  <label class="textBody--sm">Companies</label>
                  <ng-select id="ddlCompanies" [items]="companies" placeholder="Select a company" [active]="selectedCompany" (selected)="companySelected($event)">
                  </ng-select>
                </div>


                <div class="form-group" *ngIf="user">
                  <label for="deleted">Account Locked Out</label>
                  <p class="textBody--xs">
                    <input type="checkbox" id="deleted" name="disabled" formControlName="disabled" class="u-marginTop--small " /> If checked this user will be unable to access the system.
                  </p>
                </div>

                <div class="form-group" *ngIf="selectedRoleName=='ContentEditor' || selectedRoleName=='Client'">
                  <label>Countries</label>
                  <p class="form-text">Which countries can this user contribute to?</p>
                  <p class="alert alert-info">
                    {{selectAll ? 'Deselect all countries' : 'Select all countries' }} <input type="checkbox" value="false" [checked]="selectAll" (click)="selectAllCountries()" />
                  </p>
                  <div class="row" [formGroup]="userForm.controls['userCountries']">
                    <div class="col col-md-4" *ngFor="let c of countries">
                      <input type="checkbox" [formControlName]="c.isoCode">
                      {{ c.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<confirmationmodal #confirmModal (onAccept)="onAccept();"></confirmationmodal>
